/**
 * SurveyGenerator
 */
export const SurveyGenerator = (function () {
  var questionCardIndex = 0; //generates unique ID for each question
  var dragCounter = 0; //dragCounter prevents dragEnter and dragLeave behaviour being triggered simultaneously

  var init =  function () {

    $('.myds-add-question').on('click', function(e) {
      addQuestion('select-question');
    });

    $('.myds-add-text-question').on('click', function(e) {
      addQuestion('text-question');
    });
    // add option to question
    $('.myds-survey').on('click', '#myds-add-option', function(e) {
      e.preventDefault();

      addOption(this);
    });
    // add other option to question
    $('.myds-survey').on('click', '#myds-add-option-other', function(e) {
      e.preventDefault();

      addOptionOther(this);
    });
    // delete option
    $('.myds-survey').on('click', '.delete-answer', function(e) {
      e.preventDefault();
      
      $(this).closest('[data-option]').remove();
    });
    // delete question
    $('.myds-survey').on('click', '.delete-question', function(e) {
      e.preventDefault();

      $(this).closest('.card').remove();
      reorderQuestions();
    });

    $('.myds-survey').on('click', '#myds-change-checkbox', function(e) {
      e.preventDefault();
      var checkboxes = $(this).closest('.card-body').find('.checkbox-control');
      var typeInput = 'radio';
      // change text of button
      $(this).text(function(i, text){
        return text === "Multiselect" ? "Singleselect" : "Multiselect";
      });
      // change the view of the checkbox between square and rounded
      $(checkboxes).each(function() {
        $(this).toggleClass('square');
      });

      if($(this).text() == 'Singleselect') {
        typeInput = 'checkbox';
      }
      // change the type of the input
      $(this).closest('.card-body').find('.myds-checkbox-input').prop('type', typeInput);
    });

    $('.myds-survey').on('click', '#myds-duplicate-question', function(e) {
      e.preventDefault();
      
      var card = $(this).closest('.card');
      duplicateQuestion(card);
    });

  }

  /**
   * Adds a question to the UI 
   * If it's an existing question from the Database, it's data is added to the card
   * Otherwise, a blank question card is displayed
   * Calls functions that add event listeners for drag & drop functionality
   * 
   * @param {*} cardQuestionType - Type of question card 'select-question' vs 'text-question'
   * @param {*} existingQuestion - Question content where the question being added is already saved
   */
  var addQuestion = function(cardQuestionType, existingQuestion) {
    if (!existingQuestion && $('.myds-question-card').length > 0) {
      questionCardIndex = $('.myds-question-card').length - 1;
    }
    
    let content = $('.myds-' + cardQuestionType).html();
    let cardID = "question-card-" + questionCardIndex;
    let card = $('<div class="card mt-3 myds-question-card" data-card="question" draggable="true" id=' + cardID + '>');
    const index = $('.myds-question-card').length;

    content = content.replace(/number/g, index);
    card.html(content + '</div>');

    if($('.myds-survey .myds-question-card').length == 0){
      $('.myds-survey').html(card);
      $('#myds-add-btns-footer>div').removeClass('d-none');
    } else {
      $('.myds-survey .myds-question-card').last().after(card);
    }

    //if it's an existing question, add the saved data
    if (existingQuestion) {
      addExistingQuestionData(card, cardQuestionType, existingQuestion);
    }

     //add drag and drop functionality event listeners - switch to javascript (not using jquery)
     let draggableCard = document.getElementById(cardID);
     addDraggableFunctionality(draggableCard);
     addDroppableFunctionality(draggableCard);
     
     //make sure user can still interact with text field without draggable taking over
     preventDraggableOnInputFields(card, cardQuestionType);
   
    questionCardIndex++;
    $("body").tooltip({ selector: '[data-toggle=tooltip]' });
  }

   /**
   * adds drag event listeners to question card as draggable element
   * 
   * @param {*} draggableCard - the question card element to add event listener to
   */
  var addDraggableFunctionality = function(draggableCard) {

    draggableCard.addEventListener('dragstart', handleDragStart);
    draggableCard.addEventListener('dragend', handleDragEnd);
   
  }
  /**
   * adds drop event listeners to question card as drop zone
   * 
   * @param {*} dropZone - the question card element to add event listener to
   */
  var addDroppableFunctionality = function(dropZone) {

    dropZone.addEventListener('dragover', handleDragOver);
    dropZone.addEventListener('dragenter', handleDragEnter);
    dropZone.addEventListener('dragleave', handleDragLeave);
    dropZone.addEventListener('drop', handleDrop);
  }

  /**
   * handles start of drag: stores the dragged element id via dataTransfer and adds styling
   * to reduce opacity
   * 
   * @param {*} e - event
   */
  var handleDragStart = function(e) {
    this.classList.add('dragging');
    e.dataTransfer.setData('source', this.id);
  }
  /**
   * handles end of drag: returns dragged element to original styling/opacity and checks if dragged over elements (drop zones)
   * still have drag/drop related styling and removes it
   */
  var handleDragEnd = function() {
    this.classList.remove('dragging');

    //if the '.drag-enter' class is still present in any of the question cards, remove it
    let draggedOverElements = document.querySelectorAll('.drag-enter');
    draggedOverElements.forEach((e) => {
      e.classList.remove('drag-enter');
    })
  }
  /**
   * Prevents default behaviour when dragged element is dragged over any given dropZone
   * 
   * @param {*} e - event
   */
  var handleDragOver = function(e) {
    e.preventDefault();
    return false;
  }
  /**
   * Adds styling that increases scale of dropZone element when dragged into
   */
  var handleDragEnter = function() {

    dragCounter++;
    this.classList.add('drag-enter');

  }
  /**
   * Removes styling that increases scale of dropZone element when dragged out of
   */
  var handleDragLeave = function() {

    dragCounter--;
    if (dragCounter === 0) {
      this.classList.remove('drag-enter');
    }
    
  }
  /**
   * Prevents default behaviour when dragged element is dropped onto dropZone.
   * Retrieves dragged element using id stored via dataTransfer.
   * Checks to make sure dragged element is not attempting to drop onto itself.
   * Gets respective indexes of dragged element and drop zone.
   * Checks if dragged element is being dragged up or down based on these indexes.
   * If it's being dragged up, inserts dragged element above the drop zone.
   * If it's being dragged down, adds the dragged element after the drop zone.
   * 
   * @param {*} e - event
   */
  var handleDrop = function(e) {
    e.stopPropagation();
    let draggedCard = document.getElementById(e.dataTransfer.getData('source'));

    if (draggedCard !== this) {

      let dropZoneIndex = Array.prototype.indexOf.call(this.parentNode.children, this);
      let draggedCardIndex = Array.prototype.indexOf.call(this.parentNode.children, draggedCard);

      //if dragging up, drop card above drop zone
      if (dropZoneIndex < draggedCardIndex) {
        this.parentNode.insertBefore(draggedCard, this);
      } else { //if dragging down, drop card below drop zone
        this.after(draggedCard);
      }
      
    }

    dragCounter = 0;
    return false;
  }

   /**
   * Prevents draggable functionality being triggered when interacting with text fields in cards
   * 
   * @param {*} card - the card to apply this to
   * @param {*} cardQuestionType - Type of question card 'select-question' vs 'text-question' determines what input fields to apply this to
   */
  var preventDraggableOnInputFields = function(card, cardQuestionType) {
     
     let selectQuestionInput = "";
     if(cardQuestionType == 'select-question') {
       selectQuestionInput = ", .myds-input-option";
     }
     $('.myds-question' + selectQuestionInput).on('focus', function(){
       card.attr('draggable', false);
       
     })
     $('.myds-question' + selectQuestionInput).on('blur', function(){
       card.attr('draggable', true);
       
     })

  }

   /**
   * Adds existing question data to a question card
   * 
   * @param {*} card - the card element the data is to be added to 
   * @param {*} cardQuestionType - Type of question card 'select-question' vs 'text-question'
   * @param {*} question - Question content to be added
   */
  var addExistingQuestionData = function(card, cardQuestionType, question) {
    let inputs = card[0].querySelector(".myds-question");
      inputs.value = question.question_text;

      if (cardQuestionType !== 'text-question') {
        
        const button = card[0].getElementsByTagName('button')[0];
        let options = card[0].querySelectorAll('[name="option"]');

        // FOR the number of radio/check options
        for (let i = 0; i < question.response_options.length; i++) {

          // Blank questions have 2 options, so we don't need to add further options if there are less than 2
          if (i < 2) {
            options[i].value = question.response_options[i];
          } else {

            // Check if it's type other
            if (question.response_options[i] === 'Other') {
              var optionButton = card[0].getElementsByTagName('button')[1];
              addOptionOther(optionButton);
            } else {
              addOption(button);
            }
            
            let additional_options = card[0].querySelectorAll('[name="option"]');
            additional_options[i].value = question.response_options[i];

          }
          // Set UI to checkbox for the options that have just been added
          if (question.question_type === 'checkbox'){
            let types = card[0].querySelectorAll('[name="checkbox-answer"]');
            types[0].setAttribute('type', 'checkbox');
            let labels = card[0].getElementsByTagName('span');
            for (let el of labels) {
              el.setAttribute('class', el.getAttribute('class')+' square');
            }
          }
        
        }
      }
  }

  var addOption = function(btn) {
    let option = $(btn).closest('.card-body').find('.myds-option');
    let x = `<a class="delete-answer ml-2 mr-1" href="" aria-hidden="true"><strong>x</strong></a>`;
    var clonedOption = option.clone();
    
    clonedOption.removeClass('myds-option');
    clonedOption.find('.myds-input-option').val('');
    clonedOption.find('.myds-input-option').attr('placeholder', 'Extra Option');
    clonedOption.find('.myds-input-option').after(x);

    // Check if there's an 'other' option - if there is add the new field above it
    var other = $(btn).closest('.card-body').find('.myds-option-other');

    if (other.length > 0) {
      clonedOption.insertBefore(other);
    } else {
      clonedOption.insertBefore(btn);
    }

  }

  var addOptionOther = function(btn) {

    // If we already have 'other' we don't want to add another
    var other = $(btn).closest('.card-body').find('.myds-option-other');

    if (other.length > 0 ) {
      return;
    }

    let option = $(btn).closest('.card-body').find('.myds-option');
    let x = `<a class="delete-answer ml-2 mr-1" href="" aria-hidden="true"><strong>x</strong></a>`;
    var clonedOption = option.clone();
    
    clonedOption.removeClass('myds-option');
    clonedOption.addClass('myds-option-other');
    clonedOption.find('.myds-input-option').val('Other');
    clonedOption.find('.myds-input-option').attr('placeholder', 'Extra Option');
    clonedOption.find('.myds-input-option').attr('disabled', 'true');
    clonedOption.find('.myds-input-option').after(x);

    var optionButton = $(btn).prev();

    clonedOption.insertBefore(optionButton);
    btn.blur();
    
  }
  var reorderQuestions = function() {
    $('.myds-question-card:visible').each(function(index, el) {
      let newIndex = index + 1;
      // changes the number of the question in the card and in the data-index attribute
      let questionNumber = $(this).find('[data-index]');
      questionNumber.attr('data-index', newIndex);
      questionNumber.text(newIndex + '.');
    });
  }

  var constructSurveyArrayObject = function () {
    let inputData = $("[data-card='question']");
    var survey = [];

    $(inputData).each(function(i, el){
      var optionsQuestions = [];
      let question = $(el).find('.myds-question');
      let options = $(el).find('input[name="option"]');
      let optionType = $(el).find('.myds-checkbox-input').attr('type');
      // check question value is not empty
      if ($(question).val() == '') {
        return Util.toggleAlert('#myds-alert-survey', 'Please fill all questions.', 'alert-primary', 8000);
      }

      $(options).each(function(index, optionEl){
        // check that all options are not empty
        if($(optionEl).val() == '') {
          return Util.toggleAlert('#myds-alert-survey', 'Please fill all options.', 'alert-primary', 8000);
        }

        optionsQuestions.push($(optionEl).val());
      });
      // creates array of objects with the questions
      survey.push({
        type: $(question).attr('name').split('-')[1],
        option_type: optionType != null ? optionType : 'textarea',
        question: $(question).val(),
        options: optionsQuestions
      });
      
    });

    return survey;
  }

  var duplicateQuestion = function (question) {

    var index = $('.myds-question-card').length;
    var clonedQuestion = question.clone().insertAfter('.myds-question-card:visible:last');

    $(clonedQuestion).find('[data-index]').attr('data-index', index);
    $(clonedQuestion).find('[data-index]').text(index + '.');
  }

  return {
    init: init,
    constructSurveyArrayObject: constructSurveyArrayObject,
    addQuestion: addQuestion
  }

}());


